import { render } from "./LanguagesSetup.vue?vue&type=template&id=3f02c787&scoped=true&ts=true"
import script from "./LanguagesSetup.vue?vue&type=script&lang=ts"
export * from "./LanguagesSetup.vue?vue&type=script&lang=ts"

import "./LanguagesSetup.vue?vue&type=style&index=0&id=3f02c787&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f02c787"]])

export default __exports__